/**
 * All possible states or events for a widget
 . Used as suffix along with WidgetTypes to log or store a widget state; e.g:
 WidgetTypes.DOM + WidgetStates.Clicked = 'apexchat_dom_chatwindow_clicked'
 */
const WidgetStates = {
    Initialized: '_init',
    Ready: '_ready',
    Created: '_created',
    ShownNormal: '_rendered',
    ShownMaximized: '_max',
    ShownMinimized: '_min',
    ShownCollapsed: '_collapsed',
    Hidden: '_hidden',
    Closed: '_closed',
    Clicked: '_clicked',
    MouseExit: '_mouse_exit',
    Refreshed: '_refreshed',
    MessageSent: '_msg_sent',
    PoppedOut: '_popout',
    VideoClicked: '_video_clicked',
    DragNDrop: '_drag_n_drop',
    // for old/visitor form
    VisitorFormClicked: '_form_clicked',
    VisitorFormSubmitted: '_form_submitted',
    // for bew/video-visitor form
    DynamicVisitorFormClicked: '_dynamic_form_clicked',
    DynamicVisitorFormSubmitted: '_dynamic_form_submitted',
    DynamicVisitorFormCancelled: '_dynamic_form_cancelled'
};
export default WidgetStates;
